import { render, staticRenderFns } from "./PchPurchaseCreditNoteCreate.vue?vue&type=template&id=900e12b2&lang=pug&"
import script from "./PchPurchaseCreditNoteCreate.vue?vue&type=script&lang=js&"
export * from "./PchPurchaseCreditNoteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchPurchaseCreditNoteCreate.vue"
export default component.exports